import moment from "moment";

export function isLessThan36HoursAgo(timestamp) {
  if (!timestamp) return false;

  const THIRTY_SIX_HOURS = 60 * 60 * 1000 * 36;
  return new Date() - new Date(timestamp) < THIRTY_SIX_HOURS;
}

export function isLessThan24HoursAgo(timestamp) {
  if (!timestamp) return false;

  const TWENTY_FOUR_HOURS = 60 * 60 * 1000 * 24;
  return new Date() - new Date(timestamp) < TWENTY_FOUR_HOURS;
}

export function addDays(date, days) {
  if (!date || !days) return null;

  const newDate = new Date(date);
  return newDate.setTime(newDate.getTime() + days * 86400000);
}

export function monthsAgo(number) {
  if (!number) return null;

  return moment().subtract(number, "months");
}

export function daysAgo(number) {
  if (!number) return null;

  return moment().subtract(number, "days");
}



// WEBPACK FOOTER //
// ./app/lib/time.js